import { Fragment, MouseEvent, useState } from "react";
import { Construction } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";

import type { IMerge } from "@framework/types";
import { Button, Menu } from "@dzambalaorg/ui-kit";

interface IMergeIngredientsProps {
  merge: IMerge;
}

export const MergeIngredients = (props: IMergeIngredientsProps) => {
  const { merge } = props;

  const [anchor, setAnchor] = useState<Element | null>(null);

  const handleMenuOpen = (event: MouseEvent): boolean => {
    event.preventDefault();
    event.stopPropagation();
    setAnchor(event.currentTarget);
    return false;
  };

  const handleMenuClose = (event: MouseEvent): void => {
    event.preventDefault();
    event.stopPropagation();
    setAnchor(null);
  };

  return (
    <Fragment>
      <Button
        intent="icon"
        aria-owns={anchor ? "merge-ingredients" : undefined}
        aria-haspopup="true"
        data-testid="MergeIngredients"
        onClick={handleMenuOpen}
        color="inherit"
      >
        <Construction />
      </Button>
      <Menu id="merge-ingredients" anchorEl={anchor} open={!!anchor} onClose={handleMenuClose}>
        {merge.price?.components.map(component =>
          component.templateId ? (
            <Menu.Item<typeof RouterLink>
              key={component.id}
              component={RouterLink}
              to={`/${component.contract?.contractType?.toLowerCase()}/templates/${component.template?.id}`}
            >
              <Menu.ItemText>
                {component.template!.title} {`${BigInt(component.amount) > 1 ? `(${component.amount})` : ""}`}
              </Menu.ItemText>
            </Menu.Item>
          ) : (
            <Menu.Item<typeof RouterLink>
              key={component.id}
              component={RouterLink}
              to={`/${component.contract?.contractType?.toLowerCase()}/contracts/${component.contract?.id}`}
            >
              <Menu.ItemText>
                {component.contract!.title} {`${BigInt(component.amount) > 1 ? `(${component.amount})` : ""}`}
              </Menu.ItemText>
            </Menu.Item>
          ),
        )}
      </Menu>
    </Fragment>
  );
};
